<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="邮箱：" prop="car_code">
                <span>{{model.email}}</span>
            </el-form-item>
            <el-form-item label="车辆昵称：" prop="display_name">
                <span>{{model.display_name}}</span>
            </el-form-item>
            <el-form-item label="CarId：" prop="car_id">
                <span>{{model.car_id}}</span>
            </el-form-item>
            <el-form-item label="VehicleId：" prop="vehicle_id">
                <span>{{model.vehicle_id}}</span>
            </el-form-item>
            <el-form-item label="VIN：" prop="vin">
                <span>{{model.vin}}</span>
            </el-form-item>
            <el-form-item label="车辆类型：" prop="car_type">
                <span>{{model.car_type}}</span>
            </el-form-item>
            <el-form-item label="车辆配置：" prop="trim_badging">
                <span>{{model.trim_badging}}</span>
            </el-form-item>
            <el-form-item label="辆车颜色：" prop="car_color">
                <span>{{model.car_color}}</span>
            </el-form-item>
            <el-form-item label="电池容量：" prop="battery_capacity">
                <span>{{model.battery_capacity}}</span>
            </el-form-item>
            <el-form-item label="满电续航：" prop="full_endurance">
                <span>{{model.full_endurance}}</span>
            </el-form-item>
            <el-form-item label="经度：" prop="lng">
                <span>{{model.lng}}</span>
            </el-form-item>
            <el-form-item label="纬度：" prop="lat">
                <span>{{model.lat}}</span>
            </el-form-item>
            <el-form-item label="剩余里程：" prop="odometer">
                <span>{{model.odometer}}</span>
            </el-form-item>
            <el-form-item label="总里程：" prop="sum_odometer">
                <span>{{model.sum_odometer}}</span>
            </el-form-item>
            <el-form-item label="剩余电量：" prop="sum_odometer">
                <span>{{model.battery_level}}%</span>
            </el-form-item>
            <el-form-item label="版本：" prop="version">
                <span>{{model.version}}</span>
            </el-form-item>
            <el-form-item label="车外温度：" prop="outside_temp">
                <span>{{model.outside_temp}}</span>
            </el-form-item>
            <el-form-item label="内车温度：" prop="inside_temp">
                <span>{{model.inside_temp}}</span>
            </el-form-item>
            <el-form-item label="创建时间：" prop="create_time">
                <span>{{model.create_time}}</span>
            </el-form-item>
            <el-form-item label="更新时间：" prop="update_time">
                <span>{{model.update_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'carInfoInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                car_id: '',
                car_code: '',
                vehicle_id: '',
                vin: '',
                car_type: '',
                car_color: '',
                battery_capacity: '',
                power: '',
                state: '',
                display_name: '',
                lng: '',
                lat: '',
                soc: '',
                odometer: '',
                sum_odometer: '',
                version: '',
                outside_temp: '',
                inside_temp: '',
                create_time: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/carinfo/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>